import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const S3StorageSignMultiFileUploadUrlError = BaseErrorSchema.extend({
  errorType: z.literal('S3StorageSignMultiFileUploadUrlError'),
  bucketName: z.string(),
  bucketRegion: z.string(),
  keyPrefix: z.string(),
  errorReason: z.string(),
});

export type S3StorageSignMultiFileUploadUrlError = z.infer<
  typeof S3StorageSignMultiFileUploadUrlError
>;
